/**
 * Раскладка редактора: ширины панелей, лежащих поверх холста.
 *
 * Панели не занимают место в сетке, а накрывают холст, поэтому холст должен
 * знать, сколько пикселей по краям закрыто: план вписывается в видимую часть,
 * а шапки видов не прячутся под панелью. Единственное место с этими числами.
 */

/** Ширины панелей редактора, пикселей */
export const EDITOR_PANELS = {
	/** Столбик инструментов слева — всегда виден в 2D и на развёртках */
	toolRail: 66,
	/** Широкий столбик инструментов: подписи справа от иконок */
	toolRailWide: 200,
	/** Выдвижная секция столбика: стены, проёмы, проводка */
	toolDrawer: 272,
	/** Выдвижная секция каталога — шире, чтобы вместить колонку разделов и карточки */
	catalogDrawer: 330,
	/** Панель свойств справа */
	properties: 280,
} as const;

/** Отдельная композитная поверхность UI поверх 2D-холста. */
export const EDITOR_OVERLAY_COMPOSITING_STYLE = {
	transform: "translateZ(0)",
} as const;

/** Отдельная замкнутая поверхность UI: Chrome Android иначе может пропустить её перерисовку. */
export const EDITOR_OVERLAY_PAINT_STYLE = {
	...EDITOR_OVERLAY_COMPOSITING_STYLE,
	contain: "paint",
} as const;

/** Сколько места слева занимает наложенная на 2D-холст панель инструментов. */
export const editorInsets = (
	drawerOpen: boolean,
	drawerWidth?: number,
	railWidth: number = EDITOR_PANELS.toolRail,
) => {
	const isMobile = typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;
	return {
		left:
			!isMobile && drawerOpen ? railWidth + (drawerWidth ?? EDITOR_PANELS.toolDrawer) : railWidth,
		right: 0,
	};
};
